import styled from 'styled-components';

export default styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
`;
